/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Nachrueckpriority1Inputs */

const en__field_nachrueckpriority1 = /** @type {(inputs: _Field_Nachrueckpriority1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`moving up priority`)
};

const de__field_nachrueckpriority1 = /** @type {(inputs: _Field_Nachrueckpriority1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nachrück Priorität`)
};

/**
* | output |
* | --- |
* | "moving up priority" |
*
* @param {_Field_Nachrueckpriority1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_nachrueckpriority1 = /** @type {((inputs?: _Field_Nachrueckpriority1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Nachrueckpriority1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_nachrueckpriority1(inputs)
	return de__field_nachrueckpriority1(inputs)
});
export { _field_nachrueckpriority1 as "_field_nachrueckPriority" }